var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6692 4.73926L0.5 16.9084V20H3.59146L15.7598 7.83008L12.6692 4.73926Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8585 0.640084C19.4485 0.230234 18.8925 0 18.3128 0C17.7331 0 17.1771 0.230234 16.7671 0.640084L13.8506 3.5609L16.9412 6.65172L19.8577 3.73507C20.0612 3.53203 20.2226 3.29085 20.3328 3.02535C20.443 2.75984 20.4997 2.47521 20.4998 2.18775C20.4999 1.90029 20.4433 1.61563 20.3332 1.35006C20.2232 1.0845 20.0619 0.843236 19.8585 0.640084Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.111701a0b702cd0023f6d7b548ce8e1f.svg";
export { ForwardRef as ReactComponent };